module.exports = __webpack_public_path__ + "static/media/icons-yc-zoom-in.bc2ce2a9.svg";